export enum ManagersEnum {
  AV = 'Area VP',
  RM = 'Regional Vice President',
  DM = 'District Manager',
  AM = 'Area Manager',
  GM = 'General Manager',
  AGM = 'Assistant General Manager',
  GMIT = 'General Manager in Training',
  DOPD = 'Director of Practice Development',
}
